import React, { useState, ReactNode } from 'react';
import { Collapse } from 'antd';
import './Collapes.scss';
const { Panel } = Collapse;

type propsType = {
  activeKey?: string | number | (string | number)[] | undefined;
  panelList: {
    title: string;
    key: string;
    collapsible?: any;
    renderPanel: () => ReactNode;
  }[];
  accordion?: boolean;
  className?: string;
};
export const TFCollapse: React.FC<propsType> = ({
  activeKey,
  panelList,
  accordion,
  className,
}) => {
  const [ActiveKey, setActiveKey] = useState(activeKey || '');
  const onChange = (key: any) => {
    setActiveKey(key);
  };

  return (
    <Collapse
      accordion={accordion === undefined ? true : accordion}
      className={`TFCollapseWrapper ${className && className}`}
      expandIconPosition="right"
      activeKey={ActiveKey}
      onChange={onChange}
    >
      {panelList?.map((itm) => (
        <Panel header={itm?.title} key={itm?.key}>
          {itm.renderPanel()}
        </Panel>
      ))}
    </Collapse>
  );
};
